import { unref } from 'vue';
import { useUser } from '@core/user';
import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

function updateNetAveragePriceFactory({
  price,
  isin,
  bourseCodeId,
}: {
  price: number;
  isin: string;
  bourseCodeId: number;
}) {
  return {
    averagePrice: price,
    isin,
    bourseCodeId,
  };
}

type UseUpdateNetAveragePriceOptions = {
  isin?: string | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onReject?: UseMutationConfig<{}>['onReject'];
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSuccess?: UseMutationConfig<{}>['onSuccess'];
};

export default function useUpdateNetAveragePriceQuery({
  isin,
  onReject,
  onSuccess,
}: UseUpdateNetAveragePriceOptions) {
  const { user } = useUser();

  const {
    execute: updateNetAveragePrice,
    isPending: isLoadingUpdateNetAveragePrice,
    ...query
    // eslint-disable-next-line @typescript-eslint/ban-types
  } = useMutation<{}>(
    ({ price }: { price: number }) =>
      API.updateNetAveragePrice(
        updateNetAveragePriceFactory({
          price,
          isin: unref(isin as string),
          bourseCodeId: user.value?.investorBourseCodes[0].id as number,
        })
      ),
    {
      onSuccess,
      onReject,
    }
  );

  return { updateNetAveragePrice, isLoadingUpdateNetAveragePrice, ...query };
}
